(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7924],{

/***/ 1646:
/***/ (function(module) {

!function(t,s){ true?module.exports=s():0}(this,(function(){"use strict";var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=31536e6,u=2628e6,d=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,a=/\[([^\]]+)]|YYYY|YY|Y|M{1,2}|D{1,2}|H{1,2}|m{1,2}|s{1,2}|SSS/g,h={years:o,months:u,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof g},f=function(t,s,n){return new g(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},v=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},g=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*h[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s]})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(d);if(e){var r=e.slice(2).map((function(t){return null!=t?Number(t):0}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*h[n]}),0)},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/o),t%=o,this.$d.months=$(t/u),t%=u,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t},y.toISOString=function(){var t=v(this.$d.years,"Y"),s=v(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=v(n,"D"),e=v(this.$d.hours,"H"),r=v(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3,o=Math.round(1e3*o)/1e3);var u=v(o,"S"),d=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",h=(d?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return"P"===h||"-P"===h?"P0D":h},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(a,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/h[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return"milliseconds"===n?s%=1e3:s="weeks"===n?$(s/h[n]):this.$d[n],s||0},y.add=function(t,s,n){var i;return i=s?t*h[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.valueOf=function(){return this.asMilliseconds()},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}(),p=function(t,s,n){return t.add(s.years()*n,"y").add(s.months()*n,"M").add(s.days()*n,"d").add(s.hours()*n,"h").add(s.minutes()*n,"m").add(s.seconds()*n,"s").add(s.milliseconds()*n,"ms")};return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)?p(this,t,1):r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)?p(this,t,-1):o.bind(this)(t,s)}}}));

/***/ }),

/***/ 21782:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calls",
      function () {
        return __webpack_require__(63712);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useExtremeFeatureAccessGate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66017);




/**
 * Extreme 功能页门控（仅 iOS-Cloud 有基础/高级绑定）
 *
 * - 未绑定高级：跳转 /ios/extreme-verification
 * - 已绑未购：出升级弹窗
 * - resetTime 未就绪：gatePending
 */ function useExtremeFeatureAccessGate(hasExtremePlan) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const resetTime = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.resetTime);
    const currentMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.currentMode);
    const deviceSwitchRevision = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.deviceSwitchRevision);
    const isIos = (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .shouldApplyIosExtremeBindGate */ .yI)(currentMode);
    const resetTimePending = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isResetTimePending */ .z6)(resetTime);
    const advancedNotBound = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isAdvancedVerificationIncomplete */ .dU)(resetTime);
    const extremePlan = hasExtremePlan === true || hasExtremePlan === "true";
    const gatePending = resetTimePending;
    const needsExtremeBindPage = isIos && !gatePending && advancedNotBound;
    const showUpgradeModal = isIos && !gatePending && !advancedNotBound && !extremePlan;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!needsExtremeBindPage) return;
        if (router.pathname === "/ios/extreme-verification") return;
        router.replace("/ios/extreme-verification");
    }, [
        needsExtremeBindPage,
        router,
        deviceSwitchRevision
    ]);
    return {
        resetTimePending,
        gatePending,
        advancedNotOver: advancedNotBound,
        needsExtremeBindPage,
        showUpgradeModal
    };
}


/***/ }),

/***/ 57921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useExtremeUpgradeRefresh; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76919);


/**
 * 订阅 Extreme 升级成功事件，刷新「当前所在功能页」的数据与 advanced 状态。
 *
 * 使用场景：页面内嵌了 ExtremeModal，用户在不离开页面的情况下完成升级后，
 * 需要去掉模糊遮罩并重新请求本页接口（如 smsChat-summary / getAllDashboard 等）。
 *
 * 刷新顺序（与 spyx / 后端缓存策略对齐）：
 * 1. notifyExtremeUpgraded 内已 await USER_SUMMARY 预缓冲（触发后台 advanced 同步）
 * 2. 本 hook 再 await primeExtremeAdvancedCache（二次预热，读到同步后的 advanced）
 * 3. 再执行 onUpgraded → 本页业务详情接口，用返回的 advanced 解锁 UI
 *
 * 注意：
 * - onUpgraded 内应复用「设备切换」时的重置 + 拉数逻辑（与 useDeviceScopedInit 保持一致）
 * - 建议先 setAdvanced(true) 乐观解锁 UI，再 dispatch 拉真实数据
 * - onUpgraded 可为 async；须 useCallback 包裹，避免重复注册监听
 *
 * @param {() => void | Promise<void>} onUpgraded - 升级成功后的刷新回调
 *
 * @example
 * useExtremeUpgradeRefresh(
 *   useCallback(() => {
 *     setAdvanced(true)
 *     dispatch(fetchUserProfile()) // hook 内已先 USER_SUMMARY，再执行此处
 *   }, [dispatch])
 * )
 */ function useExtremeUpgradeRefresh(onUpgraded) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!onUpgraded) return;
        const handler = async ()=>{
            await (0,src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .primeExtremeAdvancedCache */ .ti)();
            await Promise.resolve(onUpgraded());
        };
        window.addEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
        return ()=>window.removeEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
    }, [
        onUpgraded
    ]);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useExtremeUpgradeRefresh)));


/***/ }),

/***/ 63712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useExtremeUpgradeRefresh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57921);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90948);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _src_api_dashboard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95629);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9473);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34745);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33185);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31909);
/* harmony import */ var src_core_components_modal_extreme_upgrade__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3769);
/* harmony import */ var src_hooks_useExtremeFeatureAccessGate__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9644);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53399);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15378);
// ** React Imports

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  .ant-picker-input {// 包裹显示两个时间input的div样式\n    width:auto;\n  }\n  .ant-picker-input > input {// 显示两个时间的input样式\n    font-family: Poppins !important;\n    font-weight: 400 !important;\n    line-height: 24px !important;\n    font-size: 16px !important;\n    text-align: center;\n    text-overflow: clip !important;  /* 禁止使用省略号 */\n    overflow: visible !important;    /* 允许文本溢出 */\n  }\n  .ant-picker-input input[date-range="start"] {\n  width: var(--firstWidth) !important;\n  }\n  .ant-picker-input input[date-range="end"] {\n    width: var(--lastWidth) !important;\n  }\n  .ant-picker-input > input::placeholder {// 显示两个时间的placeholder样式（占位符\n    color:#ADADAD;\n  }\n  .ant-picker-suffix {// 框内icon样式\n    order:-1;\n    opacity:1 !important;\n    margin-right:11px;\n  }\n  '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




// ** Next Imports



// request












const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z;
const CustomRangePicker = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(RangePicker)(_templateObject());
const ScrollDiv = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)("div")({
    "@media (max-width: 990px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
dayjs__WEBPACK_IMPORTED_MODULE_8___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_9___default()));
const Calls = ()=>{
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)((state)=>state.Common);
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common");
    let Advanced = window.localStorage.getItem("Advanced");
    Advanced = Advanced == null || Advanced == 0 ? true : false;
    // ** State
    const [initCalls, setInitCalls] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [allCalls, setAllCalls] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [calls, setCalls] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [active, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("CALL_HISTORY");
    const [currentState, setCurrentState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("all");
    const [antdSelectedDates, setAntdSelectedDates] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [currentPage, setCurrentPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1);
    const [reloadKey, setReloadKey] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0) // 日期变化后强制重拉接口
    ;
    const domRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [maxNum, setMaxNum] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true) //正在加载获取数据
    ;
    const [advanced, setAdvanced] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true) // 是否购买高级服务
    ;
    const [fetchLoading, setFetchLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true) // 数据获取中
    ;
    const basicNotOver = [
        null,
        ""
    ].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
    ;
    const advancedNotOver = [
        null,
        ""
    ].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
    ;
    // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
    const { gatePending , showUpgradeModal  } = (0,src_hooks_useExtremeFeatureAccessGate__WEBPACK_IMPORTED_MODULE_15__/* .useExtremeFeatureAccessGate */ .t)(advanced);
    const [justVerified, setJustVerified] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false) // 是否为刚完成验证
    ;
    // 查询数据
    const setCallData = async (page, pageSize)=>{
        const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        // 获取最近的10笔订单
        let res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_16__.getUserAccountOrder)({
            page: 1,
            pageSize: 10
        });
        // 查找有限期最长的订单
        const lastOrder = res.data.sort((a, b)=>dayjs__WEBPACK_IMPORTED_MODULE_8___default()(b.expire_time).valueOf() - dayjs__WEBPACK_IMPORTED_MODULE_8___default()(a.expire_time).valueOf())[0];
        // 计算是否为增值服务上线前付费用户
        // 增值服务上线前付费用户状态更新
        let response = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_7__/* .getAllDashboard */ .gP)({
            username,
            params: {
                category: active,
                offset: (page - 1) * pageSize,
                limit: pageSize,
                // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
                ...(0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_13__/* .buildTimeParams */ .W2)(antdSelectedDates),
                deviceUdid: JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["Unique Identifier"] : ""
            }
        });
        setIsLoading(false);
        const advanced = username == null || !("advanced" in response) || [
            "true",
            true
        ].includes(response === null || response === void 0 ? void 0 : response.advanced) // 高级服务开通状态
        ;
        setAdvanced(advanced) // 设置高级服务状态
        ;
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_12__/* .changeExtremeService */ .xU)(advanced)) // 更新高级服务状态
        ;
        if (response.data.contents == null) {
            setMaxNum(true);
            setFetchLoading(false);
            return;
        }
        let result = response.data.contents.map((item)=>{
            return {
                ...item,
                time: active == "VOICEMAIL" ? dayjs__WEBPACK_IMPORTED_MODULE_8___default()(Number("".concat(item.date, "000"))).format("YYYY-MM-DD HH:mm") : dayjs__WEBPACK_IMPORTED_MODULE_8___default()(Number("".concat(item.date))).format("YYYY-MM-DD HH:mm"),
                url: "https://cos.spyx.com/".concat(item.url, ".mp3"),
                type: active,
                playing: false,
                sender: active == "VOICEMAIL" ? item.sender : item.displayName
            };
        });
        if (advanced) {
            setAllCalls((old)=>[
                    ...old,
                    ...result
                ]);
            setInitCalls(result);
        } else {
            const mockData = (0,src_utils__WEBPACK_IMPORTED_MODULE_19__/* .generateMockData */ .W)(result) // 生成模拟数据
            ;
            setAllCalls([
                ...mockData
            ]);
            setInitCalls([
                ...mockData
            ]);
        }
        setFetchLoading(false);
    };
    // 页数变化，获取新数据
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!maxNum && advanced) setCallData(currentPage, 50);
    }, [
        currentPage,
        active,
        reloadKey
    ]);
    // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
    (0,src_hooks_useExtremeUpgradeRefresh__WEBPACK_IMPORTED_MODULE_3__/* .useExtremeUpgradeRefresh */ .v)((0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setAdvanced(true);
        setAllCalls([]);
        setInitCalls([]);
        setCalls([]);
        setCurrentPage(1);
        setMaxNum(false);
        setFetchLoading(true);
        setCallData(1, 50);
    }, []));
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    // 监听进度条滚动
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const handleScroll = ()=>{
            if (domRef.current) {
                const { scrollTop , scrollHeight , clientHeight  } = domRef.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = domRef.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handleScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (scroll >= 100 && advanced) {
            setCurrentPage((old)=>old + 1);
        }
    }, [
        scroll
    ]);
    // 获取当前状态的数据
    const getStateData = function() {
        let datas = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : antdSelectedDates;
        const _list = [
            ...allCalls
        ];
        let list = _list.filter((item)=>{
            if (currentState === "all") {
                return item;
            } else if (currentState === "outgoing") {
                return item.originated === 1;
            } else if (currentState === "missed") {
                return item.originated === 0 && item.duration === 0;
            } else if (currentState === "incoming") {
                return item.originated === 0 && item.duration !== 0;
            } else {
                return item;
            }
        });
        if (datas && datas.length === 2) {
            const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_13__/* .buildTimeParams */ .W2)(datas);
            const newDateList = list.filter((item)=>{
                var _created;
                // item.date 在不同分类下可能是秒或毫秒，统一成毫秒再比较
                const itemTime = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_13__/* .toMillis */ .eq)((_created = item.created) !== null && _created !== void 0 ? _created : item.date);
                return itemTime >= startTime && itemTime <= endTime;
            });
            list = newDateList;
        }
        setCalls(()=>[
                ...list
            ]);
    };
    // 查看不同状态的通话记录
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        getStateData();
    }, [
        allCalls,
        currentState
    ]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const title = t("Call");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_12__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_12__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        locale
    ]);
    // 获取今天的日期
    const today = dayjs__WEBPACK_IMPORTED_MODULE_8___default()().format("YYYY-MM-DD");
    // 获取七天前的日期
    const sevenDaysAgo = dayjs__WEBPACK_IMPORTED_MODULE_8___default()().subtract(7, "day").format("YYYY-MM-DD");
    //选择日期范围
    const handleDateChange = (dates)=>{
        const picked = dates && dates.length === 2 ? dates : [];
        setAntdSelectedDates(picked);
        if (!advanced) {
            // 未开通高级：列表是本地模拟数据，直接本地筛
            getStateData(picked);
            return;
        }
        // 重置分页后由 useEffect 带 startTime/endTime 重新请求接口
        setAllCalls([]);
        setInitCalls([]);
        setCalls([]);
        setMaxNum(false);
        setCurrentPage(1);
        setFetchLoading(true);
        setReloadKey((old)=>old + 1);
    };
    // 获取最宽日期选择器占位符宽度
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // 开始时间&结束时间
        let firstDate = "0000-00-00";
        let lastDate = "0000-00-00";
        // 开始时间宽度&结束时间宽度
        let firstWidth = 0;
        let lastWidth = 0;
        const span = document.createElement("span");
        span.style.setProperty("font-family", "Poppins", "important");
        span.style.setProperty("font-size", "16px", "important");
        span.style.setProperty("font-weight", "400", "important");
        span.style.setProperty("line-height", "24px", "important");
        span.style.visibility = "hidden";
        span.innerText = firstDate;
        // 获取第一个占位符宽度
        document.body.appendChild(span);
        firstWidth = span.offsetWidth;
        document.body.removeChild(span);
        // 获取第二个占位符宽度
        span.innerText = lastDate;
        document.body.appendChild(span);
        lastWidth = span.offsetWidth;
        document.body.removeChild(span);
        // 插入至html标签样式中用于调用
        document.documentElement.style.setProperty("--firstWidth", "".concat(firstWidth, "px"));
        document.documentElement.style.setProperty("--lastWidth", "".concat(lastWidth, "px"));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "w-[144px] Blds:w-[528px] h-[33px] Blds:h-[42px] flex bg-[#EAEAEA] Blds:bg-inherit rounded-[8px] mb-[15px] mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "all" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("all"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    src: "/images/calls/all-call.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "all call"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("All Calls")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "missed" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("missed"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    src: "/images/calls/missed.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "missed"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("Missed Calls")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "outgoing" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("outgoing"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    src: "/images/calls/outgoing.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "outgoing"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("Outgoing Calls")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex-1 Blds:flex-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "".concat(currentState === "incoming" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                            onClick: ()=>setCurrentState("incoming"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    src: "/images/calls/incoming.svg",
                                    width: 24,
                                    height: 24,
                                    alt: "incoming"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                    children: t("Incoming Calls")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative",
                children: [
                    !fetchLoading && !gatePending && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: !basicNotOver && !advancedNotOver && !justVerified ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: showUpgradeModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_modal_extreme_upgrade__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                open: true
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ScrollDiv, {
                        ref: domRef,
                        className: "bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] Mlg:h-[calc(var(--vh2)*100-139px)] lg:Bxl:h-[calc(var(--vh2)*100-148px)] Bxls:Headers5:h-[calc(var(--vh2)*100-206px)] Header5:big:h-[calc(var(--vh2)*100-271px)] bigs:h-[calc(var(--vh2)*100-331px)] px-[16px] smj:px-0 pb-[20px] flex flex-col ".concat(advanced ? "overflow-auto" : "overflow-hidden", " relative z-10"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("table", {
                                className: "border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full smj:hidden ".concat(!advanced && "blur-[16px] select-none"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                        className: "sticky top-0 bg-[#FFF]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                                className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                                children: t("NAME OR NUMBER")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                                className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                                children: t("STATE")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                                className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                                children: t("DURATION")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                                className: "text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]",
                                                children: t("DATE")
                                            })
                                        ]
                                    }),
                                    calls.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.displayName
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap flex items-center pr-[30px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                                            className: "mr-[5px]",
                                                            src: row.originated === 0 ? row.duration === 0 ? "/images/calls/missed.svg" : "/images/calls/incoming.svg" : "/images/calls/outgoing.svg",
                                                            width: 24,
                                                            height: 24,
                                                            alt: row.originated === 0 ? row.duration === 0 ? "missed" : "incoming" : "outgoing"
                                                        }),
                                                        row.originated === 0 ? row.duration === 0 ? t("Missed") : t("Incoming") : t("Outgoing")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_8___default().duration(row.duration, "seconds").format("mm:ss")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.time
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "smjs:hidden h-auto ".concat(!advanced && "blur-[16px] select-none"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "w-full p-[15px_15px_12px] sticky top-0 bg-white border-[#e6e6e6] border-b-[0.5px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomRangePicker, {
                                                format: "YYYY-MM-DD" // 左右两边显示的日期格式
                                                ,
                                                placeholder: [
                                                    sevenDaysAgo,
                                                    today
                                                ],
                                                separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "text-[#ADADAD]",
                                                    children: "~"
                                                }),
                                                suffixIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                                    src: "/images/calls/calendar.svg",
                                                    alt: "calendar",
                                                    width: 18,
                                                    height: 18
                                                }),
                                                className: "w-full h-[40px] bg-[#F8F8F8]",
                                                inputReadOnly: true,
                                                onChange: handleDateChange,
                                                getPopupContainer: ()=>document.getElementById("customRangePicker")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                id: "customRangePicker"
                                            })
                                        ]
                                    }),
                                    calls.map((row, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "h-[64px] flex w-full",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "w-[20px] mt-3 mr-2 ml-[15px]",
                                                    children: row.originated === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                                        src: "/images/calls/outgoing2.svg",
                                                        alt: "outgoing",
                                                        width: 18,
                                                        height: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "border-[#e6e6e6] border-b-[0.5px] w-full flex flex-col justify-center h-[64px] font-[Poppins]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            className: "text-[16px] font-[500] leading-[24px] ".concat(row.originated === 0 && row.duration === 0 ? " text-[#FE1616]" : " text-[#000000]"),
                                                            children: row.displayName || row.address
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: "flex justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                    className: "text-[14px] font-[400] leading-[21px] text-[#8A8A8E]",
                                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_8___default().duration(row.duration, "seconds").format("HH:mm:ss")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                    className: "text-[14px] font-[400] text-[#8A8A8E] leading-[21px] mr-[15px]",
                                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_8___default()(row.time).format("YYYY/MM/DD HH:mm")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index))
                                ]
                            }),
                            advanced && allCalls.length == 0 && !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                                children: [
                                    t("It appears theres no data to show here yet"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                    t("If data exists it may take up to 1 hour to download and appear"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                    t("We suggest checking back in a little while")
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Calls);


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,5378,2862,770,210,1664,5983,3769,9774,2888,179], function() { return __webpack_exec__(21782); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);